export const formatExpiryDate = (isoDate: string): string | null => {
  const d = new Date(isoDate);
  if (isNaN(d.getTime())) {
    return null;
  }
  return d.toLocaleDateString(undefined, {month: 'short', day: 'numeric', year: 'numeric'});
};

export const getRenewalCreditsText = (numCredits: number, renewalDate: string): string | null => {
  const formattedDate = formatExpiryDate(renewalDate);

  if (!formattedDate) {
    return null;
  }

  return window.i18next.t('pmwjs_x_credits_added_on_date_with_renewal', {numCredits: numCredits.toLocaleString(), date: formattedDate});
};
